import domain from './domain';

// Reset work reports
export const resetWorkReports = domain.createEvent('resetWorkReports');
